import { AllPlatforms, platform } from '@/common/bridge';
import * as env from '@/common/environment';
import { store } from '@/store';
import { UserState } from '@/store/user';
import { compareVersionNumbers } from '@/vendor/pleased-sdk/util';

export type CompiledPlatformSupport = Partial<
  Record<AllPlatforms, (currentVersion: string) => boolean>
>;

export const getVersionSupportCheckers = (
  featureName: string,
  noVersionReturnValue: boolean = true
): CompiledPlatformSupport => ({
  app: currentVersion => {
    const minAppVersionSupport = env.get('app')?.minVersionSupport;
    const minFeatureVersionSupport = minAppVersionSupport?.[featureName];

    if (!minFeatureVersionSupport?.MIN_APP) return noVersionReturnValue;

    return (
      compareVersionNumbers(currentVersion, minFeatureVersionSupport.MIN_APP) >=
      0
    );
  },
  ios: currentVersion => {
    const minAppVersionSupport = env.get('app')?.minVersionSupport;
    const minFeatureVersionSupport = minAppVersionSupport?.[featureName];

    if (!minFeatureVersionSupport?.MIN_IOS) return noVersionReturnValue;

    return (
      compareVersionNumbers(currentVersion, minFeatureVersionSupport.MIN_IOS) >=
      0
    );
  },
  web: () => true,
  wap: () => true,
});

export function checkVersionSupported (
  fieldName: string,
  noVersionReturnValue?: boolean
): boolean {
  const vuexState = store.state as { user: UserState };

  return Boolean(
    // eslint-disable-next-line standard/computed-property-even-spacing
    getVersionSupportCheckers(fieldName, noVersionReturnValue)[
      platform as AllPlatforms
    ]?.(vuexState.user.customerAppVersion || '')
  );
}
